/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */

import {APIService} from '@/core/util/services/api.service';

type MyAdjustmentAction = {
  component: string;
  props: object;
};

type MyAdjustmentSecondaryAction = {
  label: string;
  context: string;
};

type useMyAdjustmentArgs = {
  primaryActions?: {[name: string]: MyAdjustmentAction};
  secondaryActions?: MyAdjustmentSecondaryAction[];
};

export type MyAdjustmentCanceled = {
  employeeAttendanceId: string;
  note: string;
  punchInTimezoneName: string;
  punchInUserTime: string;
  punchOutTimezoneName: string;
  punchOutUserTime: string;
  submissionStatus: number;
};

const cancel: MyAdjustmentAction = {
  component: 'oxd-button',
  props: {
    label: 'Cancel',
    displayType: 'label-warn',
    size: 'medium',
    onClick: null,
  },
};

const edit: MyAdjustmentAction = {
  component: 'oxd-button',
  props: {
    label: 'Edit',
    displayType: 'label-info',
    size: 'medium',
    onClick: null,
  },
};

export default function useMyAdjustmentActions(
  http: APIService,
  {primaryActions = {cancel, edit}}: useMyAdjustmentArgs = {},
) {
  const processMyAdjustmentAction = (
    id: number,
    row: MyAdjustmentCanceled,
    submissionStatus: number | string,
  ) => {
    row.submissionStatus = Number(submissionStatus);
    return http.update(id, row);
  };

  return {
    myAdjustmentActions: primaryActions,
    processMyAdjustmentAction,
  };
}
